// Generated by scripts/import-cinema-contacts.py — do not edit manually.
import type { CinemaContactDetails } from "./cinemaContacts.types";

export const CINEMA_CONTACTS_LIST: CinemaContactDetails[] = [
    {
        "cinemaId": 1,
        "name": "Алмаз",
        "seoName": "Мягкий кинотеатр Алмаз",
        "city": "Челябинск",
        "sessionsPhone": "8 (351) 210-11-11",
        "email": "almaz@comfortkino.ru",
        "schedule": "ПН-ПТ: 10:00 - 23:30\nСБ-ВС: 09:00 – 23:30",
        "address": "Челябинск, Копейское шоссе, д.64",
        "latitude": "55.145094",
        "longitude": "61.451200",
        "departments": [
            {
                "title": "Отдел кадров",
                "phones": [
                    "+7 (351) 247-45-48 (доб.247)"
                ],
                "emails": [
                    "job@mega74.ru"
                ]
            },
            {
                "title": "Отдел рекламы",
                "contactPerson": "Галина Суковатицина",
                "phones": [
                    "+7 (351) 247-45-48 (доб.278)"
                ],
                "emails": [
                    "galina@pochta456.ru"
                ]
            },
            {
                "title": "Офис менеджер (центральный офис)",
                "phones": [
                    "+7 (351) 247-45-48 (доб.118)"
                ],
                "emails": [
                    "secretar@mega74.ru"
                ]
            },
            {
                "title": "Отдел развития (новые проекты и строительство)",
                "phones": [
                    "+7 (351) 263-75-53"
                ],
                "emails": [
                    "or1@mega74.ru"
                ]
            }
        ],
        "requisites": {
            "name": "ООО «ИМПЕРИЯ ИГР»",
            "inn": "7452030395",
            "kpp": "745301001",
            "ogrn": "1027403888126",
            "actualAddress": "454008, г. Челябинск, Свердловский проспект, 51А",
            "legalAddress": "454008, г. Челябинск, Свердловский проспект, 51А",
            "bankAccount": "40702810816240002786",
            "corrAccount": "30101810145250000411",
            "bik": "044525411"
        }
    },
    {
        "cinemaId": 2,
        "name": "Гудок",
        "seoName": "Мягкий кинотеатр Гудок",
        "city": "Самара",
        "sessionsPhone": "8 (846) 951-11-11",
        "email": "smr@comfortkino.ru",
        "schedule": "ПН-ПТ: 10:45 - 00:00\nСБ-ВС: 10:00 – 00:00",
        "address": "Самара, Красноармейская, 131",
        "latitude": "53.186643",
        "longitude": "50.126050",
        "departments": [
            {
                "title": "Отдел кадров",
                "emails": [
                    "yashko@mega74.ru"
                ]
            },
            {
                "title": "Отдел рекламы",
                "phones": [
                    "+7 (991) 396-12-49",
                    "+7 (991) 396-00-58"
                ],
                "emails": [
                    "korchak@mega74.ru",
                    "nikulina@nadparom.ru",
                    "miheeva.a@pochta456.ru"
                ]
            },
            {
                "title": "Офис менеджер (центральный офис)",
                "phones": [
                    "+7 (351) 247-45-48 (доб.118)"
                ],
                "emails": [
                    "safina@mega74.ru"
                ]
            },
            {
                "title": "Отдел развития (новые проекты и строительство)",
                "phones": [
                    "+7 (351) 263-75-53"
                ],
                "emails": [
                    "or1@mega74.ru"
                ]
            }
        ],
        "requisites": {
            "name": "ООО «ИМПЕРИЯ ИГР»",
            "inn": "7452030395",
            "kpp": "745301001",
            "ogrn": "1027403888126",
            "actualAddress": "454008, г. Челябинск, Свердловский проспект, 51А",
            "legalAddress": "454008, г. Челябинск, Свердловский проспект, 51А",
            "bankAccount": "40702810209280004597",
            "corrAccount": "30101810145250000411",
            "bik": "044525411"
        }
    },
    {
        "cinemaId": 3,
        "name": "Депо",
        "seoName": "Мягкий кинотеатр Депо",
        "city": "Нижний Тагил",
        "sessionsPhone": "8 (3435) 37-97-97",
        "email": "tag@comfortkino.ru",
        "schedule": "ПН-ПТ: 10:00 - 00:00\nСБ-ВС: 09:30 – 00:00",
        "address": "Нижний Тагил, Свердловское шоссе, д.31В",
        "latitude": "57.876964",
        "longitude": "60.014265",
        "departments": [
            {
                "title": "Отдел кадров",
                "emails": [
                    "job@mega74.ru"
                ]
            },
            {
                "title": "Отдел рекламы",
                "phones": [
                    "+7 (351) 247-45-48 (доб.278)"
                ],
                "emails": [
                    "galina@pochta456.ru",
                    "serebryakov.a@mega74.ru"
                ]
            },
            {
                "title": "Офис менеджер (центральный офис)",
                "phones": [
                    "+7 (351) 247-45-48 (доб.118)"
                ],
                "emails": [
                    "safina@mega74.ru"
                ]
            },
            {
                "title": "Отдел развития (новые проекты и строительство)",
                "phones": [
                    "+7 (351) 263-75-53"
                ],
                "emails": [
                    "or1@mega74.ru"
                ]
            }
        ],
        "requisites": {
            "name": "ООО «ИМПЕРИЯ ИГР»",
            "inn": "7452030395",
            "kpp": "745301001",
            "ogrn": "1027403888126",
            "actualAddress": "454008, г. Челябинск, Свердловский проспект, 51А",
            "legalAddress": "454008, г. Челябинск, Свердловский проспект, 51А",
            "bankAccount": "40702810209280004597",
            "corrAccount": "30101810145250000411",
            "bik": "044525411"
        }
    },
    {
        "cinemaId": 4,
        "name": "Мегаполис",
        "seoName": "Мягкий кинотеатр Мегаполис",
        "city": "Челябинск",
        "sessionsPhone": "8 (351) 247-45-45",
        "email": "info@mega74.ru",
        "schedule": "ПН-ВС: 09:00 – 01:00",
        "address": "Челябинск, Свердловский проспект, д.51А",
        "latitude": "55.169961",
        "longitude": "61.391100",
        "departments": [
            {
                "title": "Отдел кадров",
                "phones": [
                    "+7 (351) 247-45-48 (доб.140)"
                ],
                "emails": [
                    "job@mega74.ru"
                ]
            },
            {
                "title": "Отдел рекламы",
                "contactPerson": "Галина Суковатицина",
                "phones": [
                    "+7 (351) 247-45-48 (доб.278)"
                ],
                "emails": [
                    "galina@pochta456.ru"
                ]
            },
            {
                "title": "Офис менеджер (центральный офис)",
                "phones": [
                    "+7 (351) 247-45-48 (доб.118)"
                ],
                "emails": [
                    "secretar@mega74.ru"
                ]
            },
            {
                "title": "Отдел развития (новые проекты и строительство)",
                "phones": [
                    "+7 (351) 263-75-53"
                ],
                "emails": [
                    "or1@mega74.ru"
                ]
            }
        ],
        "requisites": {
            "name": "ООО «ИМПЕРИЯ ИГР»",
            "inn": "7452030395",
            "kpp": "745301001",
            "ogrn": "1027403888126",
            "actualAddress": "454008, г. Челябинск, Свердловский проспект, 51А",
            "legalAddress": "454008, г. Челябинск, Свердловский проспект, 51А",
            "bankAccount": "40702810816240002786",
            "corrAccount": "30101810145250000411",
            "bik": "044525411"
        }
    },
    {
        "cinemaId": 6,
        "name": "Мегаполис",
        "seoName": "Мягкий кинотеатр Мегаполис Уфа",
        "city": "Уфа",
        "sessionsPhone": "8 (347) 291-23-23",
        "email": "ufa@comfortkino.ru",
        "schedule": "ПН-ВС: 10:00 – 01:55",
        "address": "Уфа, ул.Менделеева, д.137",
        "latitude": "54.713475",
        "longitude": "55.993582",
        "departments": [
            {
                "title": "Отдел кадров",
                "phones": [
                    "+7 (347) 292-30-90 (доб.529)"
                ],
                "emails": [
                    "rabota@mega02.ru"
                ]
            },
            {
                "title": "Отдел рекламы",
                "contactPerson": "Галина Суковатицина",
                "phones": [
                    "+7 (351) 247-45-48 (доб.278)"
                ],
                "emails": [
                    "galina@pochta456.ru"
                ]
            },
            {
                "title": "Офис менеджер (центральный офис)",
                "phones": [
                    "+7 (351) 247-45-48 (доб.118)"
                ],
                "emails": [
                    "secretar@mega74.ru"
                ]
            },
            {
                "title": "Отдел развития (новые проекты и строительство)",
                "phones": [
                    "+7 (351) 263-75-53"
                ],
                "emails": [
                    "or1@mega74.ru"
                ]
            }
        ],
        "requisites": {
            "name": "ООО «ИМПЕРИЯ ИГР»",
            "inn": "7452030395",
            "kpp": "745301001",
            "ogrn": "1027403888126",
            "actualAddress": "454008, г. Челябинск, Свердловский проспект, 51А",
            "legalAddress": "454008, г. Челябинск, Свердловский проспект, 51А",
            "bankAccount": "40702810816240002786",
            "corrAccount": "30101810145250000411",
            "bik": "044525411"
        }
    },
    {
        "cinemaId": 7,
        "name": "Семейный парк",
        "seoName": "Мягкий кинотеатр Семейный парк",
        "city": "Магнитогорск",
        "sessionsPhone": "+7 (3519) 393-392",
        "email": "hello@comfortkino.ru",
        "schedule": "ПН-ПТ: 11:00 - 23:30\nСБ-ВС: 10:00 – 23:30",
        "address": "Магнитогорск, пр-т К.Маркса, 172",
        "latitude": "53.378537",
        "longitude": "58.976433",
        "departments": [
            {
                "title": "Отдел кадров",
                "emails": [
                    "yudintseva93@list.ru"
                ]
            },
            {
                "title": "Отдел рекламы",
                "phones": [
                    "+7 (351) 247-45-48 (доб.278)"
                ],
                "emails": [
                    "ivanov.v@mega74.ru",
                    "galina@pochta456.ru"
                ]
            },
            {
                "title": "Офис менеджер (центральный офис)",
                "phones": [
                    "+7 (351) 247-45-48 (доб.118)"
                ],
                "emails": [
                    "safina@mega74.ru"
                ]
            },
            {
                "title": "Отдел развития (новые проекты и строительство)",
                "phones": [
                    "+7 (351) 263-75-53"
                ],
                "emails": [
                    "or1@mega74.ru"
                ]
            }
        ],
        "requisites": {
            "name": "ООО «ИМПЕРИЯ ИГР»",
            "inn": "7452030395",
            "kpp": "745301001",
            "ogrn": "1027403888126",
            "actualAddress": "454008, г. Челябинск, Свердловский проспект, 51А",
            "legalAddress": "454008, г. Челябинск, Свердловский проспект, 51А",
            "bankAccount": "40702810209280004597",
            "corrAccount": "30101810145250000411",
            "bik": "044525411"
        }
    },
    {
        "cinemaId": 8,
        "name": "Фокус",
        "seoName": "Мягкий кинотеатр Фокус",
        "city": "Челябинск",
        "sessionsPhone": "+7 (351) 211-65-65",
        "email": "info@mega74.ru",
        "schedule": "ПН-ПТ: 11:30 - 23:00\nСБ-ВС: 09:30 – 23:00",
        "address": "Челябинск, ул. Молдавская, 16 (3 этаж)",
        "latitude": "55.190888",
        "longitude": "61.303946",
        "departments": [
            {
                "title": "Отдел кадров",
                "phones": [
                    "+7 (351) 247-45-48 (доб.247)"
                ],
                "emails": [
                    "job@mega74.ru"
                ]
            },
            {
                "title": "Отдел рекламы",
                "contactPerson": "Галина Суковатицина",
                "phones": [
                    "+7 (351) 247-45-48 (доб.278)"
                ],
                "emails": [
                    "galina@pochta456.ru"
                ]
            },
            {
                "title": "Офис менеджер (центральный офис)",
                "phones": [
                    "+7 (351) 247-45-48 (доб.118)"
                ],
                "emails": [
                    "secretar@mega74.ru"
                ]
            },
            {
                "title": "Отдел развития (новые проекты и строительство)",
                "phones": [
                    "+7 (351) 263-75-53"
                ],
                "emails": [
                    "or1@mega74.ru"
                ]
            }
        ],
        "requisites": {
            "name": "ООО «ИМПЕРИЯ ИГР»",
            "inn": "7452030395",
            "kpp": "745301001",
            "ogrn": "1027403888126",
            "actualAddress": "454008, г. Челябинск, Свердловский проспект, 51А",
            "legalAddress": "454008, г. Челябинск, Свердловский проспект, 51А",
            "bankAccount": "40702810816240002786",
            "corrAccount": "30101810145250000411",
            "bik": "044525411"
        }
    },
    {
        "cinemaId": 9,
        "name": "Отрада",
        "seoName": "Мягкий кинотеатр Отрада",
        "city": "Москва",
        "sessionsPhone": "8 (495) 73-73-773",
        "email": "hello@comfortkino.ru",
        "schedule": "ПН-ЧТ: 11:00 - 23:00\nПТ: 11:00 - 23:30\nСБ: 10:00 - 23:30\nВС: 10:00 – 23:00",
        "address": "Москва, МО, г.о. Красногорск, пос. Отрадное, Пятницкое шоссе, д.1, стр.1",
        "latitude": "55.875435",
        "longitude": "37.332021",
        "departments": [
            {
                "title": "Отдел кадров",
                "contactPerson": "Алина Гурьева",
                "emails": [
                    "guryeva@mega74.ru"
                ]
            },
            {
                "title": "Отдел рекламы",
                "phones": [
                    "+7 (351) 247-45-48 (доб.278)"
                ],
                "emails": [
                    "ivanov.v@mega74.ru",
                    "galina@pochta456.ru"
                ]
            },
            {
                "title": "Офис менеджер (центральный офис)",
                "phones": [
                    "+7 (351) 247-45-48 (доб.118)"
                ],
                "emails": [
                    "safina@mega74.ru"
                ]
            },
            {
                "title": "Отдел развития (новые проекты и строительство)",
                "phones": [
                    "+7 (351) 263-75-53"
                ],
                "emails": [
                    "or1@mega74.ru"
                ]
            }
        ],
        "requisites": {
            "name": "ООО «ИМПЕРИЯ ИГР»",
            "inn": "7452030395",
            "kpp": "745301001",
            "ogrn": "1027403888126",
            "actualAddress": "454008, г. Челябинск, Свердловский проспект, 51А",
            "legalAddress": "454008, г. Челябинск, Свердловский проспект, 51А",
            "bankAccount": "40702810209280004597",
            "corrAccount": "30101810145250000411",
            "bik": "044525411"
        }
    },
    {
        "cinemaId": 10,
        "name": "Космопорт",
        "seoName": "Мягкий кинотеатр Космопорт",
        "city": "Самара",
        "sessionsPhone": "8 (846) 374-16-22",
        "email": "hello@comfortkino.ru",
        "schedule": "ПН-ПТ: 10:45 - 00:00\nСБ-ВС: 10:00 – 00:00",
        "address": "Самара, ул. Дыбенко 30, ТРК Космопорт",
        "latitude": "53.20753",
        "longitude": "50.1955732",
        "departments": [
            {
                "title": "Отдел кадров",
                "emails": [
                    "yashko@mega74.ru"
                ]
            },
            {
                "title": "Отдел рекламы",
                "phones": [
                    "+7 (991) 396-12-49",
                    "+7 (991) 396-00-58"
                ],
                "emails": [
                    "nikulina@nadparom.ru",
                    "korchak@mega74.ru",
                    "miheeva.a@pochta456.ru"
                ]
            },
            {
                "title": "Офис менеджер (центральный офис)",
                "phones": [
                    "+7 (351) 247-45-48 (доб.118)"
                ],
                "emails": [
                    "safina@mega74.ru"
                ]
            },
            {
                "title": "Отдел развития (новые проекты и строительство)",
                "phones": [
                    "+7 (351) 263-75-53"
                ],
                "emails": [
                    "or1@mega74.ru"
                ]
            }
        ],
        "requisites": {
            "name": "ООО «ИМПЕРИЯ ИГР»",
            "inn": "7452030395",
            "kpp": "745301001",
            "ogrn": "1027403888126",
            "actualAddress": "454008, г. Челябинск, Свердловский проспект, 51А",
            "legalAddress": "454008, г. Челябинск, Свердловский проспект, 51А",
            "bankAccount": "40702810816240002786",
            "corrAccount": "30101810145250000411",
            "bik": "044525411"
        }
    },
    {
        "cinemaId": 11,
        "name": "Мегасити",
        "seoName": "Мягкий кинотеатр Мегасити",
        "city": "Самара",
        "sessionsPhone": "8 (846) 201-21-22",
        "email": "hello@comfortkino.ru",
        "schedule": "ПН-ПТ: 12:00 - 24:00\nСБ-ВС: 10:00 – 24:00",
        "address": "Самара, ул. Ново-Садовая 160М,\nТРК Мегасити",
        "latitude": "53.2247765",
        "longitude": "50.1679517",
        "departments": [
            {
                "title": "Отдел кадров",
                "emails": [
                    "yashko@mega74.ru"
                ]
            },
            {
                "title": "Отдел рекламы",
                "phones": [
                    "+7 (991) 396-09-37",
                    "+7 (991) 396-00-58"
                ],
                "emails": [
                    "korchak@mega74.ru",
                    "sarkisyan.v@mega74.ru",
                    "miheeva.a@mega74.ru"
                ]
            },
            {
                "title": "Офис менеджер (центральный офис)",
                "phones": [
                    "+7 (351) 247-45-48 (доб.118)"
                ],
                "emails": [
                    "safina@mega74.ru"
                ]
            },
            {
                "title": "Отдел развития (новые проекты и строительство)",
                "phones": [
                    "+7 (351) 263-75-53"
                ],
                "emails": [
                    "or1@mega74.ru"
                ]
            }
        ],
        "requisites": {
            "name": "ООО «СТАРЫЙ ГОРОД»",
            "inn": "7453266555",
            "kpp": "745301001",
            "ogrn": "1147453002663",
            "actualAddress": "454091, г.Челябинск, Свердловский пр-кт, 51 А, оф.428",
            "legalAddress": "454091, г.Челябинск, Свердловский пр-кт, 51 А, оф.428",
            "bankAccount": "40702810409280001602",
            "corrAccount": "30101810145250000411",
            "bik": "044525411"
        }
    },
    {
        "cinemaId": 12,
        "name": "Веер",
        "seoName": "Мягкий кинотеатр Веер",
        "city": "Екатеринбург",
        "sessionsPhone": "8 (343) 221-67-07",
        "email": "ekb@comfortkino.ru",
        "schedule": "ПН-ВС: 10:00 – 00:00",
        "address": "Екатеринбург, пр-т Космонавтов, 108Д",
        "latitude": "56.916713",
        "longitude": "60.613258",
        "departments": [
            {
                "title": "Отдел кадров",
                "phones": [
                    "+7 (351) 247-45-48 (доб.247)"
                ],
                "emails": [
                    "job@mega74.ru"
                ]
            },
            {
                "title": "Отдел рекламы",
                "phones": [
                    "+7 (351) 247-45-48 (доб.278)"
                ],
                "emails": [
                    "galina@pochta456.ru",
                    "serebryakov.a@mega74.ru"
                ]
            }
        ],
        "requisites": {
            "name": "ООО «ИМПЕРИЯ ИГР»",
            "inn": "7452030395",
            "kpp": "745301001",
            "ogrn": "1027403888126",
            "actualAddress": "454008, г. Челябинск, Свердловский проспект, 51А",
            "legalAddress": "454008, г. Челябинск, Свердловский проспект, 51А",
            "bankAccount": "40702810209280004597",
            "corrAccount": "30101810145250000411",
            "bik": "044525411"
        }
    },
    {
        "cinemaId": 13,
        "name": "СпешиLove",
        "seoName": "Мягкий кинотеатр СпешиLove",
        "city": "Пермь",
        "sessionsPhone": "8 (342) 259-55-55",
        "email": "",
        "schedule": "ПН-ПТ: 11:00 - 00:00\nСБ-ВС: 10:00 – 00:00",
        "address": "Пермь, ул. Спешилова, 114",
        "latitude": "58.0395700",
        "longitude": "56.1909060",
        "departments": [
            {
                "title": "Отдел кадров",
                "phones": [
                    "+7 (351) 247-45-48 (доб.247)"
                ],
                "emails": [
                    "job@mega74.ru"
                ]
            },
            {
                "title": "Отдел рекламы",
                "emails": [
                    "Ivanov.v@mega74.ru"
                ]
            },
            {
                "title": "Коллективные посещения, сертификаты",
                "phones": [
                    "+7 (967) 900-38-33"
                ],
                "emails": [
                    "pavlovai@mega74.ru"
                ]
            },
            {
                "title": "Коммерческое размещение в кинотеатре",
                "phones": [
                    "+7 (351) 247-45-48 (доб.278)"
                ],
                "emails": [
                    "galina@pochta456.ru"
                ]
            }
        ],
        "requisites": {
            "name": "ООО «ИМПЕРИЯ ИГР»",
            "inn": "7452030395",
            "kpp": "745301001",
            "ogrn": "1027403888126",
            "actualAddress": "454008, г. Челябинск, Свердловский проспект, 51А",
            "legalAddress": "454008, г. Челябинск, Свердловский проспект, 51А",
            "bankAccount": "40702810209280004597",
            "corrAccount": "30101810145250000411",
            "bik": "044525411"
        }
    }
] as CinemaContactDetails[];

export const CINEMA_CONTACTS: Record<number, CinemaContactDetails> = Object.fromEntries(CINEMA_CONTACTS_LIST.map(item => [item.cinemaId, item]));
